import { render, staticRenderFns } from "./ProductUrlTmpl.vue?vue&type=template&id=009e3574&scoped=true&"
import script from "./ProductUrlTmpl.vue?vue&type=script&lang=js&"
export * from "./ProductUrlTmpl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009e3574",
  null
  
)

export default component.exports